// @flow
import store from 'app/common/redux/store/singleton';
import type { SpammyClickthroughWarning } from 'app/common/redux/reducers/ui/spammyClickthroughWarning';
import {
  dismissSpammyClickthroughWarning,
  showSpammyClickthroughWarning,
} from 'app/common/redux/actions/spammyClickthroughWarning';

export const dispatchShowSpammyClickthroughWarning = (spamCheck: SpammyClickthroughWarning) =>
  store.instance.dispatch(showSpammyClickthroughWarning(spamCheck));

export const dispatchDismissSpammyClickthroughWarning = () =>
  store.instance.dispatch(dismissSpammyClickthroughWarning());

export default null;
